// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_jz-0";
export var discountCodeInput = "_jz-1";